import { ref } from 'vue';
import ComplectationRepository from '@/repositories/complectation/ComplectationRepository.ts';
import {
    Complectation,
    ComplectationCreateForm,
    ComplectationsRequestFilter,
    ComplectationsPaginator, ComplectationUpdateForm, ComplectationOptionsList, ComplectationOptionItemList,
} from '@/types/complectation.type.ts';
import { PaginationMeta } from '@/types/pagination-meta.ts';
import useLoading from '@/utils/useLoading.ts';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useComplectationRepository() {
    const arComplectations = ref<Complectation[]>([]);
    const complectationPaginationMeta = ref<PaginationMeta | null>(null);
    const { isLoading: isComplectationsLoading, setLoading: setComplectationsLoading } = useLoading();
    const complectationRepository = new ComplectationRepository();

    function getComplectations(requestFilter: ComplectationsRequestFilter): void {
        setComplectationsLoading(true);

        complectationRepository.getComplectations(requestFilter)
            .then((complectationsPaginator: ComplectationsPaginator) => {
                arComplectations.value = complectationsPaginator.data;
                complectationPaginationMeta.value = complectationsPaginator.meta;
                setComplectationsLoading(false);
            });
    }

    function getComplectation(id: number): Promise<Complectation> {
        return complectationRepository.getComplectation(id);
    }

    function createComplectation(createForm: ComplectationCreateForm): Promise<void> {
        return complectationRepository.createComplectation(createForm);
    }

    function updateComplectation(id: number, updateForm: ComplectationUpdateForm): Promise<void> {
        return complectationRepository.updateComplectation(id, updateForm);
    }

    function deleteComplectation(id: number): Promise<void> {
        return complectationRepository.deleteComplectation(id);
    }

    function getComplectationOptions(): Promise<ComplectationOptionsList> {
        return complectationRepository.getComplectationOptions();
    }

    function getComplectationOption(symbolic_code: string): Promise<ComplectationOptionItemList> {
        return complectationRepository.getComplectationOption(symbolic_code);
    }

    function getComplectationOptionValues(symbolic_code: string): Promise<Record<string, string>> {
        return complectationRepository.getComplectationOptionValues(symbolic_code);
    }

    function getComplectationsByModelId(modelId: number): Promise<Complectation[]> {
        return complectationRepository.getComplectationsByModelId(modelId);
    }

    return {
        arComplectations,
        complectationPaginationMeta,
        isComplectationsLoading,
        getComplectations: getComplectations,
        getComplectation: getComplectation,
        createComplectation: createComplectation,
        updateComplectation: updateComplectation,
        deleteComplectation: deleteComplectation,
        getComplectationOptions: getComplectationOptions,
        getComplectationOption: getComplectationOption,
        getComplectationOptionValues: getComplectationOptionValues,
        getComplectationsByModelId: getComplectationsByModelId,
    };
}
